import { Component } from '@angular/core';
import { EventsModule } from '../../../../events/events.module';
import { LayoutModule } from '../../../layout/layout.module';

@Component({
  selector: 'app-events-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    EventsModule,
  ],
  templateUrl: './events-dashboard-page.component.html',
  styleUrl: './events-dashboard-page.component.sass',
})
export class EventsDashboardPageComponent { }
